
import { defineComponent, computed, onMounted } from "vue";
import type { PropType } from "vue";

interface NavigationItem {
  Url: string;
  DisplayName: string;
  Id: string;
  PageTitle: string;
  Children: NavigationItem[];
  Active: boolean;
}

export default /*#__PURE__*/ defineComponent({
  name: "AppNavigation",
  props: {
    root: Object as PropType<NavigationItem>,
  },
  setup(props) {
    const hasSecondLevel = computed(() => {
      let hasChildren = false;

      props.root?.Children.forEach(function (item) {
        if (item.Active) {
          hasChildren = true;
        }
      });
      return hasChildren;
    });

    const close = () => {
      const menuToggle = document.getElementById("menu-toggle");
      menuToggle?.click();
    };

    onMounted(() => {
      const primaryNav: HTMLElement | null =
        document.getElementById("primary-navigation");
      const secondLevelElement =
        document.getElementsByClassName("second-level");
      const secondLevelHeight = secondLevelElement[0]?.clientHeight;

      if (secondLevelHeight > 0 && primaryNav) {
        primaryNav.style.marginBottom = secondLevelHeight + "px";
      }
    });

    return { hasSecondLevel, close };
  },
});
